import React, { useEffect, useState } from 'react';
import {
  SidebarContainer,
  Tabs,
  NavContainer,
  TabsContainer,
  LogoutContainer,
  Text,
  StyledNavLink,
  Dot,
  Bg,
} from './HamburgerSidebar.styles';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../store/slice/auth/asyncThunks';

import UseAnimations from 'react-useanimations';
import menu3 from 'react-useanimations/lib/menu4';

import { ReactComponent as Clients } from '../../assets/icons/clients.svg';
import { ReactComponent as Calendar } from '../../assets/icons/calendar.svg';
import { ReactComponent as Templates } from '../../assets/icons/templates.svg';
import { ReactComponent as Logo } from '../../assets/icons/logoBlack.svg';
import { ReactComponent as Inbox } from '../../assets/icons/inbox.svg';
import { ReactComponent as Profile } from '../../assets/icons/profile1.svg';
import { ReactComponent as Logout } from '../../assets/icons/logout.svg';
import { ReactComponent as Notifications } from '../../assets/icons/notifications.svg';
import { selectNumOfUnreadNotifications } from '../../store/slice/notification/slice';
import { selectHasUnSeenMessages } from '../../store/slice/chat/slice';

const navLinks = [
  { to: '/clients?page=1', icon: <Clients />, text: 'Clients' },
  { to: '/calendar', icon: <Calendar />, text: 'Calendar' },
  { to: '/inbox', icon: <Inbox />, text: 'Inbox' },
  { to: '/notifications?page=1', icon: <Notifications />, text: 'Notifications' },
  { to: '/templates?page=1', icon: <Templates />, text: 'Templates' },
  { to: '/profile', icon: <Profile />, text: 'Profile' },
];

const HamburgerSidebar = () => {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const numOfUnreadNotifications = useSelector(selectNumOfUnreadNotifications);
  const hasUnSeenMessages = useSelector(selectHasUnSeenMessages);
  const [open, setOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(open);

  const onLogout = () => {
    dispatch(logout())
      .unwrap()
      .then(() => {
        navigation('/');
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    let timer;
    if (open) {
      setIsVisible(true);
    } else {
      timer = setTimeout(() => setIsVisible(false), 250);
    }

    return () => clearTimeout(timer);
  }, [open]);

  useEffect(() => {
    if (isVisible) {
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.style.paddingLeft = 0;
      window.scrollTo(0, 0);
    } else {
      document.documentElement.style.overflow = 'auto';
    }
  }, [isVisible]);

  return (
    <>
      <SidebarContainer $open={open}>
        <div onClick={() => setOpen(!open)}>
          <UseAnimations animation={menu3} size={32} />
        </div>
        <Logo style={{ alignSelf: 'center' }} width={123} height={24} />

        <LogoutContainer onClick={onLogout}>
          <Logout />
          <Text>Log Out</Text>
        </LogoutContainer>
      </SidebarContainer>

      {isVisible && (
        <>
          <Bg $open={open} />
          <TabsContainer $open={open}>
            <Tabs>
              <NavContainer>
                {navLinks.map(({ to, icon, text }) => (
                  <StyledNavLink key={to} to={to}>
                    {icon}
                    {text}
                    {to === '/notifications?page=1' && numOfUnreadNotifications !== 0 && <Dot />}
                    {to === '/inbox' && hasUnSeenMessages && <Dot />}
                  </StyledNavLink>
                ))}
              </NavContainer>
            </Tabs>
          </TabsContainer>
        </>
      )}
    </>
  );
};

export default HamburgerSidebar;
